module.exports = __webpack_public_path__ + "img/logo-openagent-green-white.c76e0b92.svg";